import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { SFGridContainer, SFGridItem } from "../../grid";
import { TextFilterGroupOption } from "./textFilterGroup";
import SFShowMoreBtn from "../../link/showMoreBtn";
import { SHOW_MORE_COUNT } from "./filterGroup";

export const DURATION_VALUES = {
  zeroToTenMins: "0-10 mins",
  tenToThirtyMins: "10-30 mins",
  thirtyToSixtyMins: "30-60 mins",
  oneToTwoHrs: "1-2 hrs",
  twoPlusHrs: "2+ hrs",
};

const DURATION_INTERVALS = {
  "0-10 mins": [0, 10],
  "10-30 mins": [10, 30],
  "30-60 mins": [30, 60],
  "1-2 hrs": [60, 120],
  "2+ hrs": [120, Infinity],
};

const DurationFilterGroup = ({
  colName,
  counts = [],
  currentSelection,
  updateCurrentSelection,
  defaultSelectedValues = [],
  disableAll = false,
}) => {
  const { t } = useTranslation();

  const [visibleCount, setVisibleCount] = useState(SHOW_MORE_COUNT);

  const handleShowMore = () => {
    setVisibleCount((prevCount) => prevCount + SHOW_MORE_COUNT);
  };

  const DURATION_LABELS = {
    zeroToTenMins: t(
      "components.fullSearchDialog.durationLabels.zeroToTenMins"
    ),
    tenToThirtyMins: t(
      "components.fullSearchDialog.durationLabels.tenToThirtyMins"
    ),
    thirtyToSixtyMins: t(
      "components.fullSearchDialog.durationLabels.thirtyToSixtyMins"
    ),
    oneToTwoHrs: t("components.fullSearchDialog.durationLabels.oneToTwoHrs"),
    twoPlusHrs: t("components.fullSearchDialog.durationLabels.twoPlusHrs"),
  };

  const durationValues = Object.values(DURATION_VALUES);

  const durationCounts = getDurationCounts(counts, durationValues);

  return (
    <SFGridContainer direction="column" spacing={0}>
      {durationValues.slice(0, visibleCount).map((value, index) => (
        <SFGridItem key={index}>
          <TextFilterGroupOption
            colName={colName}
            label={DURATION_LABELS[value]}
            value={value}
            count={durationCounts.find((x) => x.value === value)?.count}
            currentSelection={currentSelection}
            updateCurrentSelection={updateCurrentSelection}
            disabled={defaultSelectedValues.includes(value) || disableAll}
          />
        </SFGridItem>
      ))}
      {visibleCount < durationValues.length && (
        <SFGridItem>
          <SFShowMoreBtn onClick={handleShowMore} />
        </SFGridItem>
      )}
    </SFGridContainer>
  );
};

export default DurationFilterGroup;

const getDurationCounts = (counts, durationValues) => {
  // Initialize an object to hold the counts for each duration interval
  const durationCounts = {};

  // Pre-fill the durationCounts with the durationValues keys set to 0
  durationValues.forEach((durationValue) => {
    durationCounts[durationValue] = 0;
  });

  for (const durationValue of durationValues) {
    const [min, max] = DURATION_INTERVALS[durationValue];
    let intervalCounts = counts?.filter(
      ({ value }) => value >= min && value <= max
    );
    durationCounts[durationValue] = intervalCounts.reduce(
      (acc, { count }) => acc + count,
      0
    );
  }

  // Map the durationCounts to the desired output format
  return durationValues.map((value) => ({
    value,
    count: durationCounts[value],
  }));
};
